import React from 'react'

const LanguageWrapper = props => {
    return (
        <div>
            {props.children}
        </div>
    )
}

export default LanguageWrapper;

export const LanguageWrapperHeader = props => {
    return (
        <div>
            {props.children}
        </div>
    )
}

export const LanguageWrapperMain = props => {
    return (
        <div>
            {props.children}
        </div>
    )
}